require("./bootstrap");

import { createApp, h } from "vue";
import { App, plugin } from "@inertiajs/inertia-vue3";
import { InertiaProgress } from "@inertiajs/progress";
import FlashMessage from './Components/FlashMessage'
import Toaster from '@meforma/vue-toaster';

const el = document.getElementById("app");

InertiaProgress.init({
    delay: 250,
    color: '#5661b3',
    includeCSS: true,
    showSpinner: true,
  });

createApp({
    render: () =>
        h(App, {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: (name) => require(`./Pages/${name}`).default,
        }),
})
    .mixin({
        created() {
            const page = JSON.parse(el.dataset.page);
            const title = this.$options.title;
            if (title) {
                document.title = `${title} - ${page.props.config.app_name ?? ""}`;
            }
        },
    })
    .component('FlashMessage', FlashMessage)
    .mixin({ methods: { route } }) // Using ziggy
    .mixin({
        methods: {
          getMediaItemLink: function (filePath, disk) {
            const page = JSON.parse(el.dataset.page);
            let rootPath = page.props.storage_paths[disk]

            if(rootPath) {
                return rootPath + filePath
            } else {
                return '/images/files.png'
            }
          },
        },
      })
    .use(plugin)
    .use(Toaster)
    .mount(el);
